export const educations = [
  {
    id: 1,
    title: "Pro Multimedia Creation License",
    duration: "2016 - 2017",
    institution: "La Rochelle University",
  },
  {
    id: 2,
    title: "Computer license",
    duration: "2013 - 2016",
    institution: "La Rochelle University",
  },
  {
    id: 3,
    title: "Science Baccalaureate",
    duration: "2012",
    institution: "Jean Brito High School",
  }
] as const;